// Configuration - Backend API URL
const BACKEND_URL = 'https://urbandsdeals.vercel.app'; // Live Vercel API

function openCodModal() {
  const modal = document.getElementById('cod-order-modal');
  if (modal) {
    modal.style.display = 'flex';
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden'; // prevent background scrolling
  }
}

function closeCodModal() {
  const modal = document.getElementById('cod-order-modal');
  if (modal) {
    modal.style.display = 'none';
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  }
}

// Close modal when clicking outside
document.addEventListener('click', function(event) {
  const modal = document.getElementById('cod-order-modal');
  if (modal && event.target === modal) {
    closeCodModal();
  }
});

function updateCodQty(change) {
  const input = document.getElementById('cod-quantity');
  let newVal = parseInt(input.value) + change;
  if (newVal < 1) newVal = 1;
  input.value = newVal;
}

async function submitCodForm() {
  const form = document.getElementById('cod-checkout-form');
  const errorContainer = document.getElementById('cod-form-error');
  const phoneInput = document.getElementById('cod-phone');
  const phoneError = document.getElementById('cod-phone-error');
  
  errorContainer.classList.add('hidden');
  errorContainer.innerText = '';
  phoneError.classList.add('hidden');

  // Basic Validation
  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }

  // Phone Validation (UAE Format)
  // Accept +971, 00971, or no country code, followed by an optional 0, then 5x and 7 digits.
  const phoneVal = phoneInput.value.replace(/[\s-]/g, '');
  const uaePhoneRegex = /^(?:\+971|00971)?0?(?:5[024568])\d{7}$/;
  if (!uaePhoneRegex.test(phoneVal)) {
    phoneError.classList.remove('hidden');
    return;
  }

  const formData = new FormData(form);
  const data = Object.fromEntries(formData.entries());
  
  const paymentMethod = data.payment_method; // 'cod' or 'online'
  
  // Format payload
  const payload = {
    product_variant_id: `gid://shopify/ProductVariant/${data.id}`,
    quantity: parseInt(data.quantity, 10),
    customer: {
      name: data.name,
      phone: phoneVal,
      email: data.email || '',
      emirate: data.emirate || 'UAE',
      address: data.address
    },
    payment_method: paymentMethod,
    source: 'dubai-ads-form',
    meta_pixel_id: data.meta_pixel_id,
    meta_capi_token: data.meta_capi_token
  };

  if (paymentMethod === 'online') {
    // Redirect to Shopify Native Checkout with pre-filled details
    // Shopify cart permalink: /cart/{variant_id}:{qty}
    let checkoutUrl = `/cart/${data.id}:${data.quantity}?`;
    let params = [];
    if (data.email && data.email.trim() !== '') {
      params.push(`checkout[email]=${encodeURIComponent(data.email)}`);
    }
    params.push(`checkout[shipping_address][first_name]=${encodeURIComponent(data.name)}`);
    params.push(`checkout[shipping_address][phone]=${encodeURIComponent(phoneVal)}`);
    params.push(`checkout[shipping_address][address1]=${encodeURIComponent(data.address)}`);
    params.push(`checkout[shipping_address][city]=${encodeURIComponent(data.emirate || 'UAE')}`);
    params.push(`checkout[shipping_address][country]=AE`); // Always AE since UAE store
    
    window.location.href = checkoutUrl + params.join('&');
    return;
  }

  // Handle COD Flow
  const submitBtn = document.querySelector('button[onclick*="cod"]');
  const submitText = document.getElementById('cod-submit-text');
  const spinner = document.getElementById('cod-submit-spinner');

  // Loading state
  submitBtn.disabled = true;
  submitText.classList.add('hidden');
  spinner.classList.remove('hidden');

  try {
    const response = await fetch('https://urbandsdeals.vercel.app/api/order/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(result.message || 'Failed to create order. Please try again.');
    }

    // Redirect to Thank You page with order number and exact ID
    window.location.href = `/pages/thank-you?order=${encodeURIComponent(result.order_number)}&id=${result.order_id}`;
    
  } catch (error) {
    console.error('COD Order Error:', error);
    errorContainer.innerText = error.message || 'Something went wrong. Please try again or use Online Payment.';
    errorContainer.classList.remove('hidden');
    
    // Reset loading state
    submitBtn.disabled = false;
    submitText.classList.remove('hidden');
    spinner.classList.add('hidden');
  }
}
